<template>
    <nav
        :class="`${menuType}-navigation`"
    >
        <ul
            :class="{
                'service-menu flex-default': menuType === 'service'
            }"
        >
            <li
                v-for="(navpoint, index) in menu"
                :key="navpoint"
                :style="{ '--i': index }"
            >
                <NuxtLink
                    :to="localePath(`${navpoint.slug}`)"
                    :target="navpoint.slug.startsWith('http') ? '_blank' : '_self'"
                    :aria-label="navpoint.title"
                    :title="navpoint.title"
                    v-touch:tap="toggleMenu"
                >
                    {{ navpoint.link_title ? navpoint.link_title : navpoint.title }}
                </NuxtLink>
            </li>

            <li v-if="menuType === 'service'">
                <a
                    @click="openModal('cookies')"
                    :title="globals.pagecontent.cookieMenuButton"
                >{{ globals.pagecontent.cookieMenuButton }}</a>
            </li>

            <li v-if="menuType === 'service'">
                <a
                    @click="openModal('newsletter')"
                    :title="globals.pagecontent.newsletterMenuButton"
                >{{ globals.pagecontent.newsletterMenuButton }}</a>
            </li>
        </ul>
    </nav>
</template>

<script setup lang="ts">
    import { useRequestStore } from '@/stores/requests'
    import { useGlobalsStore } from "@/stores/globals"

    const props = defineProps<{
        menuType: string
    }>()

    const localePath = useLocalePath()

    const requestStore = useRequestStore()
    const globalsStore = useGlobalsStore()

    const { pageIndex, globals } = storeToRefs(requestStore)
    const { menuState } = storeToRefs(globalsStore)

    const menu = ref<any>()

    watch(pageIndex, (newVal) => {
        if (newVal && Object.keys(pageIndex.value).length > 0) {
            menu.value = Object.values(pageIndex.value?.global_index).filter((page: any) => page.menu === props.menuType)
        }
	}, { immediate: true })

    const toggleMenu = <Function>() => {
        if (props.menuType === 'main') {
            const menu = document.querySelector('.main-menu') as HTMLElement;
            menuState.value = false
        }
    }

    const openModal = <Function>(modalContent: string) => {
        useEvent('toggleModal', {
            open: true,
            content: modalContent
        })
    }
</script>